import React, { useContext, useState } from 'react';
import cn from 'classnames';

import styles from './Works.module.css';
import baseStyle from '../components.module.css';
import WorksList from './WorksList';
import WorksNameList from './WorksNameList';
import LanguageContext from '../context/LanguageContext';
import { worksTitle, worksTitleUA } from '../../data/worksData';

export default function Works({ className, toWorksRef, isMobile }) {
    const [isNameListOpen, setIsNameListOpen] = useState(false);

    const [listNameActive, setListNameActive] = useState('all');

    const { language } = useContext(LanguageContext);

    const toggleListNameActive = (listName) => {
        setListNameActive('');
        setTimeout(() => setListNameActive(listName), 200);
        setIsNameListOpen(false);
    };
    const onWorksNameListClose = () => {
        setIsNameListOpen(false);
    };

    const onWorksNameListToggler = () => {
        setIsNameListOpen((state) => !state);
    };

    return (
        <div className={cn(className, baseStyle.fadeInLeft)} ref={toWorksRef}>
            <div className={baseStyle.topField}></div>
            <div className={cn(baseStyle.title, styles.worksTitle)}>
                <h2>{language === 'en' ? worksTitle : worksTitleUA}</h2>
                <div className={baseStyle.workListWrapper}>
                    <WorksNameList
                        isNameListOpen={isNameListOpen}
                        listNameActive={listNameActive}
                        toggleListNameActive={toggleListNameActive}
                        onWorksNameListClose={onWorksNameListClose}
                        onWorksNameListToggler={onWorksNameListToggler}
                        language={language}
                    />
                </div>
            </div>
            <WorksList
                listNameActive={listNameActive}
                isMobile={isMobile}
                language={language}
            />
            <div className={baseStyle.bottomField}></div>
        </div>
    );
}
